import '.g1{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g2{padding-left:1.5rem;}.ssr-plugin'
import '.g3{margin:1rem 0;}.ssr-plugin'
import '.g4{color:var(--gray-700);}.ssr-plugin'
import '.g5{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g1 g2 g3 g4 g5"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
